import {createContext, useContext} from "react";

import {initialSwapFlowState} from "./SwapFlowContext.contants";
import {ContextUsedOutsideProviderError} from "../../../core/util/error/ContextUsedOutsideProviderError";
import {
  SwapFlowDispatchContextValue,
  SwapFlowStateContextValue
} from "./SwapFlowContext.types";

const SwapFlowDispatchContext = createContext<SwapFlowDispatchContextValue>(null);
const SwapFlowStateContext = createContext<SwapFlowStateContextValue | null>(
  initialSwapFlowState
);

SwapFlowStateContext.displayName = "SwapFlowStateContext";
SwapFlowDispatchContext.displayName = "SwapFlowDispatchContext";

function useSwapFlowState() {
  const state = useContext(SwapFlowStateContext);

  if (!state) {
    throw new ContextUsedOutsideProviderError(SwapFlowStateContext);
  }

  return state;
}

function useSwapFlowDispatch() {
  const dispatch = useContext(SwapFlowDispatchContext);

  if (!dispatch) {
    throw new ContextUsedOutsideProviderError(SwapFlowDispatchContext);
  }

  return dispatch;
}

export {
  SwapFlowStateContext,
  SwapFlowDispatchContext,
  useSwapFlowState,
  useSwapFlowDispatch
};
